import api from './api';

const BASE_PATH = '/api/national-university-results';

const nationalUniversityResultService = {
    getCaptcha: (program, sessionToken) =>
        api.get(`${BASE_PATH}/captcha`, {
            params: {
                program,
                ...(sessionToken ? { sessionToken } : {}),
            },
        }),

    getProfessionalExams: (course) =>
        api.get(`${BASE_PATH}/exams`, {
            params: { course },
        }),

    fetchResult: (payload) =>
        api.post(`${BASE_PATH}/fetch`, payload),
};

export default nationalUniversityResultService;
